"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PromotionFilter_1 = require("../model/PromotionFilter");

var PromotionFilterConverter_1 = require("./PromotionFilterConverter");

var PromotionFilterConverterImpl =
/*#__PURE__*/
function (_PromotionFilterConve) {
  _inherits(PromotionFilterConverterImpl, _PromotionFilterConve);

  function PromotionFilterConverterImpl() {
    _classCallCheck(this, PromotionFilterConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionFilterConverterImpl).apply(this, arguments));
  }

  _createClass(PromotionFilterConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PromotionFilter_1.PromotionFilter(source.ids, source.externalIds, source.states, source.excludeStates, source.promotionTypeIds, source.promotionWeekType, source.years, source.weeks, source.select, source.groupOfSitesIds, source.storeSpecifications, source.kpis, source.effectInterval, source.validityInterval, source.filter, source.themeIds, source.stateFlags, source.promoSplitOptions, source.dateToGte, source.affectsDate);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        ids: source.ids,
        externalIds: source.externalIds,
        states: source.states,
        excludeStates: source.excludeStates,
        promotionTypeIds: source.promotionTypeIds,
        promotionWeekType: source.promotionWeekType,
        years: source.years,
        weeks: source.weeks,
        select: source.select,
        groupOfSitesIds: source.groupOfSitesIds,
        storeSpecifications: source.storeSpecifications,
        kpis: source.kpis,
        effectInterval: source.effectInterval,
        validityInterval: source.validityInterval,
        filter: source.filter,
        themeIds: source.themeIds,
        stateFlags: source.stateFlags,
        promoSplitOptions: source.promoSplitOptions,
        dateToGte: source.dateToGte,
        affectsDate: source.affectsDate
      });
      return result;
    }
  }]);

  return PromotionFilterConverterImpl;
}(PromotionFilterConverter_1.PromotionFilterConverter);

exports.PromotionFilterConverterImpl = PromotionFilterConverterImpl;